import SelectBox from "components/Common/SelectBox"
import React from "react"
import { Card, CardBody, Col, Input, Label, Row, Table } from "reactstrap"
import Dimensions from "./Jackets/Dimensions"
import OtherDimensions from "./Jackets/OtherDimensions"
import Specifications from "./Jackets/Specifications"
import DateInput from "components/Common/DateInput"
import "../style.css"
import { BranchOptions } from "components/CustomSelect"
import DimensionInput from "components/Common/DimensionInput"

function TabJacket(props) {
  const { config } = props

  const {
    handleCommonInput,
    handleJacketInput,
    deliveryMethodOptions,
    deliveryMethodValue,
  } = config
  return (
    <Row>
      <Col xl={9} lg={12}>
        <Card>
          <CardBody>
            <Row>
              <Col sm={6}>
                <Table bordered>
                  <tbody>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>店舗</td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          isAsync
                          loadOptions={config.loadBranch}
                          defaultValue={config.branchValue}
                          value={config.branchValue}
                          onChange={e => handleCommonInput(e, "storeId")}
                          formatOptionLabel={item => (
                            <BranchOptions item={item} />
                          )}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>種別</td>
                      <td style={{ padding: 5 }}>
                        <Row>
                          <Col>
                            <Input
                              defaultChecked={config.payload.type === "Bespoke"}
                              onChange={e => handleCommonInput(e, "type")}
                              className="me-2 me-xl-1"
                              type="radio"
                              id="BeSpoke"
                              name="type"
                              value="Bespoke"
                            />
                            <Label className="mb-0" htmlFor="BeSpoke">
                              Bespoke
                            </Label>
                          </Col>
                          <Col>
                            <Input
                              defaultChecked={config.payload.type === "MTM"}
                              onChange={e => handleCommonInput(e, "type")}
                              className="me-2 me-xl-1"
                              type="radio"
                              id="MTM"
                              name="type"
                              value="MTM"
                            />
                            <Label htmlFor="MTM" className="mb-0">
                              MTM
                            </Label>
                          </Col>
                          <Col>
                            <Input
                              defaultChecked={config.payload.type === "RTW"}
                              type="radio"
                              className="me-2 me-xl-1"
                              onChange={e => handleCommonInput(e, "type")}
                              id="RTW"
                              name="type"
                              value="RTW"
                            />
                            <Label htmlFor="RTW" className="mb-0">
                              RTW
                            </Label>
                          </Col>
                        </Row>
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>仮縫い</td>
                      <td style={{ padding: 5 }}>
                        <Row>
                          <Col>
                            <Input
                              defaultChecked={config.payload.basting}
                              onChange={e =>
                                handleCommonInput(e, "basting", true)
                              }
                              className="me-2"
                              type="radio"
                              name="basting"
                              id="bastingOn"
                            />
                            <Label htmlFor="bastingOn" className="mb-0">
                              あり
                            </Label>
                          </Col>
                          <Col>
                            <Input
                              defaultChecked={!config.payload.basting}
                              onChange={e =>
                                handleCommonInput(e, "basting", false)
                              }
                              className="me-2"
                              type="radio"
                              name="basting"
                              id="bastingOff"
                            />
                            <Label htmlFor="bastingOff" className="mb-0">
                              なし
                            </Label>
                          </Col>
                        </Row>
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>仮縫い日</td>
                      <td style={{ padding: 5 }}>
                        <DateInput
                          style={{ height: 33 }}
                          className="form-control"
                          name="fittingDate"
                          onChange={e => handleCommonInput(e[0], "fittingDate")}
                          // value={config.payload.fittingDate}
                          disabled={!config.payload.basting}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>納期日</td>
                      <td style={{ padding: 5 }}>
                        <Input type="text" style={{ height: 33 }} disabled />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>出来上日</td>
                      <td style={{ padding: 5 }}>
                        <DateInput
                          style={{ height: 33 }}
                          className="form-control"
                          value=""
                          onChange={() => null}
                          disabled
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col sm={6}>
                <Table bordered>
                  <tbody>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>顧客名</td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          isAsync={true}
                          loadOptions={config.loadCustomer}
                          defaultOptions={config.customerOptions}
                          defaultValue={config.customerValue}
                          value={config.customerValue}
                          onChange={e => handleCommonInput(e, "customerId")}
                          // isDisabled={config.payload.storeId === 0}
                          isDisabled={!!config.payload.guest}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54, opacity: config.guestHidden }}>
                      <td style={{ width: 115 }}>
                        <Input
                          className="me-2"
                          type="checkbox"
                          defaultChecked={config.payload.guest}
                          onChange={e => handleCommonInput(e, "guest")}
                          name="guest"
                          id="guest"
                          disabled={!config.guestHidden}
                        />
                        <Label htmlFor="guest" className="mb-0">
                          新規お客様
                        </Label>
                      </td>
                      <td style={{ padding: 5 }}>
                        <Input
                          type="text"
                          style={{ height: 33 }}
                          placeholder="ゲスト名を入力"
                          name="guestName"
                          value={config.payload.guestName}
                          disabled={!config.payload.guest}
                          onChange={e => handleCommonInput(e, "guestName")}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>受注日</td>
                      <td style={{ padding: 5 }}>
                        <DateInput
                          className="form-control"
                          // value={config.payload.orderDate}
                          onChange={e => handleCommonInput(e[0], "orderDate")}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>担当者</td>
                      <td style={{ padding: 5 }}>
                        <Input disabled type="text" style={{ height: 33 }} />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>プライス税抜</td>
                      <td style={{ padding: 5 }}>
                        {/* <Input
                          type="number"
                          style={{ height: 33 }}
                          className="form-control"
                          name="priceWithoutTax"
                          defaultValue={
                            config.payload.jacket.priceWithoutTax || ""
                          }
                          value={config.payload.jacket.priceWithoutTax || ""}
                          onChange={e =>
                            handleJacketInput(e, "priceWithoutTax")
                          }
                        /> */}
                        <DimensionInput
                          name="priceWithoutTax"
                          defaultValue={config.payload.jacket.priceWithoutTax}
                          value={config.payload.jacket.priceWithoutTax || ""}
                          onValueChange={(val, name) =>
                            handleJacketInput(val, name)
                          }
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>プライス税込</td>
                      <td style={{ padding: 5 }}>
                        <DimensionInput
                          disabled
                          name="priceTaxIncluded"
                          value={config.payload.jacket.priceTaxIncluded || ""}
                          defaultValue={
                            config.payload.jacket.priceTaxIncluded || ""
                          }
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
      <Col xl={3} lg={6}>
        <Card>
          <CardBody>
            <Table bordered>
              <tbody>
                <tr>
                  <td style={{ padding: 10 }}>
                    <p className="mb-0">納品方法</p>
                    <SelectBox
                      options={deliveryMethodOptions}
                      value={config.jacketDeliveryMethod}
                      isClearable={false}
                      onChange={e => handleJacketInput(e, "deliveryMethod")}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 10 }}>
                    <p className="mb-0">サンプル</p>
                    <Input type="checkbox" id="サンプル" className="me-2" />
                    <Label className="mb-0" htmlFor="サンプル">
                      サンプル
                    </Label>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 10 }}>
                    <p className="mb-0">予定納品日</p>
                    <DateInput
                      // value={config?.payload?.jacket?.scheduledDeliveryDate}
                      onChange={e =>
                        handleJacketInput(e, "scheduledDeliveryDate")
                      }
                      className="form-control"
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
      <Col sm={12}>
        <Specifications config={config} />
        <Dimensions config={config} />
      </Col>
      <Col sm={12}>
        <OtherDimensions config={config} />
      </Col>
      {config?.orderSheets?.hasMemo ? (
        <Col sm={12}>
          <Card>
            <CardBody>
              <p>メモ</p>
              <textarea
                className="form-control"
                onChange={e => handleCommonInput(e, "memo")}
                rows={8}
                value={config?.payload?.memo}
              ></textarea>
            </CardBody>
          </Card>
        </Col>
      ) : null}
    </Row>
  )
}

export default TabJacket
